/* import __COLOCATED_TEMPLATE__ from './no-data-cta.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();